export type SimpleMenuItem = {
  label: string;
  uri: string;
};

export type ParentMenuItem = {
  title: string;
  children: SimpleMenuItem[];
};

export type MenuItem = SimpleMenuItem | ParentMenuItem;

export type MenuItems = MenuItem[];

export const MENU_ITEMS_2: MenuItems = [
  {
    label: "Home",
    uri: "/",
  },
  {
    title: "Sport",
    children: [
      {
        label: "NRL",
        uri: "/category/nrl",
      },
      {
        label: "AFL",
        uri: "/category/afl",
      },
      {
        label: "EPL",
        uri: "/category/epl",
      },
      {
        label: "NBA",
        uri: "/category/nba",
      },
      {
        label: "NFL",
        uri: "/category/nfl",
      },
      {
        label: "BBL",
        uri: "/category/bbl",
      },
    ],
  },
  {
    label: "Contributors",
    uri: "/contributors",
  },
  {
    label: "Videos",
    uri: "/videos",
  },

  {
    label: "VC Loophole Calculator",
    uri: "/vc-loophole-calculator",
  },
  {
    label: "Shop",
    uri: "/shop",
  },
];

export const MENU_ITEMS = {
  data: {
    menus: {
      nodes: [
        {
          id: "dGVybToy",
          databaseId: 2,
          name: "Menu 1",
          menuItems: {
            edges: [
              {
                node: {
                  id: "cG9zdDoxOTUzOTc3",
                  label: "NRL",
                  parentId: null,
                  target: null,
                  url: "https://scplaybook.com.au/nrl",
                  uri: "/category/nrl",
                  title: null,
                },
              },
              {
                node: {
                  id: "cG9zdDoxOTUzOTc3",
                  label: "AFL",
                  parentId: null,
                  target: null,
                  url: "https://scplaybook.com.au/category/AFL",
                  uri: "/category/AFL",
                  title: null,
                },
              },
              {
                node: {
                  id: "cG9zdDoxOTUzOTc4",
                  label: "EPL",
                  parentId: null,
                  target: null,
                  url: "https://scplaybook.com.au/epl",
                  uri: "/category/epl",
                  title: null,
                },
              },
              {
                node: {
                  id: "cG9zdDoxOTUzOTc4",
                  label: "NBA",
                  parentId: null,
                  target: null,
                  url: "https://scplaybook.com.au/category/nba",
                  uri: "/category/nba",
                  title: null,
                },
              },
              {
                node: {
                  id: "cG9zdDoxOTUzOTc4",
                  label: "NFL",
                  parentId: null,
                  target: null,
                  url: "https://scplaybook.com.au/NFL",
                  uri: "/category/NFL",
                  title: null,
                },
              },
              {
                node: {
                  id: "cG9zdDoyMTYwOTE5",
                  label: "BBL",
                  parentId: null,
                  target: null,
                  url: "https://scplaybook.com.au/bbl",
                  uri: "/category/bbl",
                  title: null,
                },
              },

              {
                node: {
                  id: "cG9zdDoxMzg=",
                  label: "Contributors",
                  parentId: null,
                  target: null,
                  url: "/contributors",
                  uri: "/contributors",
                  title: null,
                },
              },
              // {
              //   node: {
              //     id: "cG9zdDoyMjMy",
              //     label: "VC Loophole",
              //     parentId: null,
              //     target: null,
              //     url: "https://scplaybook.com.au/vc-loophole-calculator/",
              //     uri: "/vc-loophole-calculator/",
              //     title: null,
              //   },
              // },
              {
                node: {
                  id: "cG9zdDoyMjMy1",
                  label: "Videos",
                  parentId: null,
                  target: null,
                  url: "/videos",
                  uri: "/videos",
                  title: null,
                },
              },
              {
                node: {
                  id: "cG9zdDoxOTYzMDMZ",
                  label: "VC Loophole Calculator",
                  parentId: null,
                  target: null,
                  url: "/vc-loophole-calculator/",
                  uri: "/vc-loophole-calculator",
                  title: null,
                },
              },
              {
                node: {
                  id: "cG9zdDoxOTYzMDMZ1",
                  label: "Shop",
                  parentId: null,
                  target: null,
                  url: "/shop/",
                  uri: "/shop",
                  title: null,
                },
              },
            ],
          },
        },
      ],
    },
  },
  extensions: {
    debug: [],
    queryAnalyzer: {
      keys: "25a890f403972d895ad421b13b364c8260bb0fb82b3ef68fe908df8a9303f128 graphql:Query list:menu list:menuitem dGVybToy cG9zdDoyMTYwOTE5 cG9zdDoxOTUzOTc3 cG9zdDoxOTUzOTc4 cG9zdDoxNDU= cG9zdDoxMzg= cG9zdDoyMjMy cG9zdDoxOTYzMDMy",
      keysLength: 218,
      keysCount: 12,
      skippedKeys: "",
      skippedKeysSize: 0,
      skippedKeysCount: 0,
      skippedTypes: [],
    },
  },
};
